export default "data:image/gif;base64,R0lGODlhAQABAJABAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAIf4fAAA7"